import gql from "graphql-tag";
import { fragment, fragmentName } from "./fragments/productDetail";

export const getOffers = (countryCode: string) => gql`
  ${fragment}
  query Offer(
    $offerIds: [String]!
  ) {
    ci${countryCode}Offers(ids: $offerIds) {
      company
      countryCode
      expiresAt
      formId
      id
      productCode
      productExternalId
      product {
        mainAttribute {
          value
          entity {
            label
            config
            code
            dataType
          }
        }
        ...${fragmentName}
      }
    }
  }
`;
